import type { CSSProperties } from 'react';

const paths = {
  map: 'm3 5 6-2 6 2 6-2v16l-6 2-6-2-6 2V5Zm6-2v16M15 5v16',
  plus: 'M12 5v14M5 12h14',
  play: 'm8 5 11 7-11 7V5Z',
  back: 'm12 5-7 7 7 7M5 12h15',
  search: 'M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z',
  upload: 'M12 16V3m-5 5 5-5 5 5M4 15v6h16v-6',
  download: 'M12 3v13m-5-5 5 5 5-5M4 15v6h16v-6',
  edit: 'm15 5 4 4M4 20l5-1L21 7l-4-4L5 15l-1 5Z',
  pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0ZM15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  people:
    'M16 21v-3a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v3M14 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM17 3a4 4 0 0 1 0 8M20 21v-3a4 4 0 0 0-3-4',
  truck:
    'M2 5h13v12H2V5Zm13 4h4l3 4v4h-7M8 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM20 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z',
  bolt: 'm13 2-9 12h7l-1 8 10-13h-7l1-7Z',
  history: 'M3 11a9 9 0 1 1 2 7M3 4v7h7M12 7v6l4 2',
  close: 'm6 6 12 12M6 18 18 6',
  target: 'M12 2v4m0 12v4M2 12h4m12 0h4M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z',
  undo: 'M3 10h11a6 6 0 0 1 0 12M3 10l6-6M3 10l6 6',
  external: 'M14 3h7v7m0-7L10 14M10 3H3v18h18v-7',
  panel: 'M3 4h18v16H3V4Zm12 0v16',
  check: 'm5 12 4 4L19 6',
  chevron: 'm9 5 7 7-7 7',
  trash: 'M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7',
  cursor: 'm4 3 6 18 3-8 8-3L4 3Z',
  line: 'm4 20 16-16M3 17v4h4M17 3h4v4',
  polygon: 'm4 7 12-4 5 14-13 4L4 7Z',
  text: 'M4 4h16M12 4v17M8 21h8',
  book: 'M12 6c-2-1-5-1.5-8-1v13c3-.5 6 0 8 1 2-1 5-1.5 8-1V5c-3-.5-6 0-8 1Zm0 0v13',
} as const;

export type IconName = keyof typeof paths;

export function Icon({
  name,
  size = 18,
  style,
}: { name: IconName; size?: number; style?: CSSProperties }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={style}
    >
      <path d={paths[name]} />
    </svg>
  );
}
